export const GET_COMING_SOON_VENUES = "GET_COMING_SOON_VENUES";
export const ADD_COMING_SOON_VENUE = "ADD_COMING_SOON_VENUE";
export const UPDATE_COMING_SOON_VENUE = "UPDATE_COMING_SOON_VENUE";
export const DELETE_COMING_SOON_VENUE = "DELETE_COMING_SOON_VENUE";
